import { Directive, OnInit } from "@angular/core";
import { Params } from "@angular/router";
import { ServerFilterParams } from "../common.model";
import { ListesideBaseClass } from "./listeside.component";

@Directive()
export abstract class ServereListesideBaseClass extends ListesideBaseClass {

  filterParams: ServerFilterParams = new ServerFilterParams();

  override urlParamsToFilterParams(params: Params, filterParams: ServerFilterParams): ServerFilterParams {

    const base = super.urlParamsToFilterParams(params, filterParams);

    return {
      ...base,
    };
  }

  override onFilterChange(filterParams: ServerFilterParams): void {

    this.filterParams = filterParams;

    this.router.navigate([], {
      queryParams: {
        beskrivelse: filterParams.tekst,
        sortOrder: filterParams.order,
        pageNumber: filterParams.pageNumber,
        pageSize: filterParams.pageSize,
        hasSystem: filterParams.hasSystem ?? null
      }
    });
  }
}
